import { render } from "./HomepageHandbook.vue?vue&type=template&id=3d1cc50f"
import script from "./HomepageHandbook.vue?vue&type=script&lang=js"
export * from "./HomepageHandbook.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__